import React from "react";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Typography } from "@mui/material";
import { Checkbox } from "@outpave/ds";
import { Stack } from "components/layout/reusableLayouts";
import { formatCashFull } from "utils/formatCash";

interface FeeCoverCheckboxProps {
  amount: number;
  currency: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

/* Fee cover must be an explicit payer opt-in. */
const FeeCoverCheckbox: React.FC<FeeCoverCheckboxProps> = ({
  amount,
  currency,
  checked,
  disabled = false,
  onChange,
}) => {
  const { t } = useTranslation();

  if (amount <= 0) {
    return null;
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
      }
      label={
        <Stack sx={{ gap: 0 }}>
          <Typography variant="body2">
            {t("payLink.CoverFees", {
              amount: formatCashFull(amount, currency),
            })}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "var(--color-text-secondary)" }}
          >
            {t("payLink.CoverFeesNote")}
          </Typography>
        </Stack>
      }
    />
  );
};

export default FeeCoverCheckbox;
